<template>
    <div class="cart_order_address_box">
        <!-- 标题 -->
        <div class="cart_order_address_title">{{$t("message.cart.ordertitle1")}}</div>
        <!-- 地址列表 -->
        <div class="cart_order_address_content">
            <!-- 列表 -->
            <el-row :gutter="20">
                <!-- 前三个地址 -->
                <template v-for="(item,index) in cart_address">
                    <el-col :span="12"
                        :key="index"
                        v-if="index<3">
                        <!-- 内容框 -->
                        <cart-order-address-item
                            :address-item="item"
                            v-if="item.address_id">
                        </cart-order-address-item>
                    </el-col>
                </template>
                <!-- 可收起部分 -->
                <template v-for="(item,index) in cart_address">
                    <el-col :span="12"
                        :key="index"
                        v-if="index>=3 && show_more">
                        <!-- 内容框 -->
                        <cart-order-address-item
                            :address-item="item"
                            v-if="item.address_id">
                        </cart-order-address-item>
                    </el-col>
                </template>
                <!-- 添加地址 -->
                <!-- <el-col :span="12" v-if="power.includes(0) || power.includes(111) || power.includes(3)"> -->
				<el-col :span="12">
                    <div class="cart_order_address_add">
                        <el-button
                            type="text"
                            @click="handleAdd"
                            class="cart_order_address_add_btn">
                            <i class="el-icon-circle-plus-outline"></i>
                            <span>{{$t("message.cart.address1")}}</span>
                        </el-button>
                    </div>
                </el-col>
            </el-row>
            <el-button
				v-if="cart_address.length>3"
                @click="show_more = show_more ? false : true"
                class="cart_order_address_more_btn">
                <!-- 显示更多 -->
                <div v-if="!show_more">
                    <span>{{$t("message.cart.address2")}}</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
                <!-- 收起 -->
                <div v-if="show_more">
                    <span>{{$t("message.cart.address3")}}</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
            </el-button>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    data() {
        return {
            show_more: false, // 是否显示更多
        }
    },
    computed: mapState({
        power: state => state.user.power,
        cart_address: state => state.order.cart_address
    }),
    components: {
        cartOrderAddressItem: () => import("@/components/cartOrderAddressItem")
    },
    methods: {
        ...mapMutations([
            "handleDialog",
			"handleFalse"
        ]),
        handleAdd(){
            let allow = this.power.includes(0) || this.power.includes(111) || this.power.includes(3);
            if(allow){
                this.handleDialog(true)
				this.handleFalse(false)
            }else{
                this.$message({
                    showClose: true,
                    message: this.$t("message.cart.errmsg2"),
                    type: "error"
                })
                return false;
            }
        }
    },
}
</script>

<style scoped>
/* 标题 */
.cart_order_address_title{
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #E4E7ED;
}
/* 内容区域 */
.cart_order_address_content{
    margin-top: 10px;
}
/* 列上下间距 */
.cart_order_address_content>.el-row>.el-col{
    margin-bottom: 10px
}
/* 添加地址 */
.cart_order_address_add{
    width: 100%;
    height: 115px;
    border: 1px solid #EBEEF5;
}
.cart_order_address_add_btn{
    width: 100%;
    height: 100%;
}
.cart_order_address_add_btn i,
.cart_order_address_add_btn span{
    font-size: 20px;
}

/* 显示更多按钮 */
.cart_order_address_more_btn{
    width: 100%;
}
</style>
